<template>
  <Transition :name="isOpen ? 'navbar-transition-opened' : 'navbar-transition-closed'">
    <div
      v-if="visible"
      :class="['navbar', { '--active': isOpen, '--background': isScrolling || background }]"
      :style="`--nav-transition-duration: ${this.transitionDuration}ms`"
    >
      <SiteNavTop @toggle-is-open="() => (isOpen = !isOpen)" />
      <SiteNavBottom />
    </div>
  </Transition>
</template>
<script>
import { bodyHelpers } from '@/helpers'

import SiteNavBottom from './SiteNavBottom.vue'
import SiteNavTop from './SiteNavTop.vue'

export default {
  name: 'SiteNav',
  components: { SiteNavBottom, SiteNavTop },
  data() {
    return {
      background: false,
      isOpen: false,
      isScrolling: false,
      transitionDuration: 200,
      visible: true,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScrollState)
  },
  unmounted() {
    window.removeEventListener('scroll', this.updateScrollState)
  },
  methods: {
    updateScrollState() {
      this.isScrolling = window.scrollY > 0
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.background = true
        bodyHelpers.lock()
      } else {
        setTimeout(() => (this.background = false), this.transitionDuration)
        bodyHelpers.unlock()
      }
    },
    $route: {
      handler(to) {
        this.visible = to?.meta?.has_nav || ['/', '/en/'].includes(to.path)
        setTimeout(() => {
          this.isOpen = false
        }, 10)
      },
      immediate: true,
    },
    '$store.state.auth.logged_in'() {
      if (!this.$store.state.auth.logged_in) {
        this.isOpen = false
      }
    },
  },
}
</script>
